import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import CustomStrong from '../CustomStrong/CustomStrong';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        emphasis: {
            fontWeight: 700,
            fontSize: '1.875rem',
            fontStyle: 'normal',
            lineHeight: '2.375rem',
            cursor: 'inherit',
            display: 'inherit',
        },
        h1: (_a = {
                fontWeight: 400,
                fontSize: '1.375rem',
                fontStyle: 'normal',
                lineHeight: 1.625,
                cursor: 'inherit',
                display: 'inherit'
            },
            _a[theme.breakpoints.down('sm')] = {
                fontSize: '1.125rem',
            },
            _a),
        h2: {
            fontWeight: 400,
            fontSize: '1.125rem',
            fontStyle: 'normal',
            lineHeight: '1.5rem',
            cursor: 'inherit',
            display: 'inherit',
        },
        h3: {
            fontWeight: 400,
            fontSize: '1rem',
            fontStyle: 'normal',
            lineHeight: '1.25rem',
            cursor: 'inherit',
            display: 'inherit',
        },
        parrafo: {
            fontWeight: 400,
            fontSize: '.875rem',
            fontStyle: 'normal',
            lineHeight: '1.125rem',
            cursor: 'inherit',
            display: 'inherit',
        },
        label: {
            fontWeight: 400,
            fontSize: '.75rem',
            fontStyle: 'normal',
            lineHeight: '1rem',
            cursor: 'inherit',
            display: 'inherit',
        },
        labelSmall: {
            fontWeight: 400,
            fontSize: '.625rem',
            fontStyle: 'normal',
            lineHeight: '.875rem',
            cursor: 'inherit',
            display: 'inherit',
        },
        customStrong: {
            display: 'inherit',
            alignItems: 'inherit',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
    });
});
var obtenerDOM = function (_a) {
    var className = _a.className, variant = _a.variant, strong = _a.strong, children = _a.children, onClick = _a.onClick, dataTestId = _a.dataTestId;
    var styles = useStyles();
    switch (variant) {
        case 'emphasis':
            return (React.createElement("em", { className: styles.emphasis + " " + className, onClick: onClick, "data-testid": dataTestId },
                React.createElement(CustomStrong, { className: styles.customStrong, type: strong }, children)));
        case 'h1':
            return (React.createElement("h1", { className: styles.h1 + " " + className, onClick: onClick, "data-testid": dataTestId },
                React.createElement(CustomStrong, { className: styles.customStrong, type: strong }, children)));
        case 'h2':
            return (React.createElement("h2", { className: styles.h2 + " " + className, onClick: onClick, "data-testid": dataTestId },
                React.createElement(CustomStrong, { className: styles.customStrong, type: strong }, children)));
        case 'h3':
            return (React.createElement("h3", { className: styles.h3 + " " + className, onClick: onClick, "data-testid": dataTestId },
                React.createElement(CustomStrong, { className: styles.customStrong, type: strong }, children)));
        case 'parrafo':
            return (React.createElement("p", { className: styles.parrafo + " " + className, onClick: onClick, "data-testid": dataTestId },
                React.createElement(CustomStrong, { className: styles.customStrong, type: strong }, children)));
        case 'label':
            return (React.createElement("label", { className: styles.label + " " + className, onClick: onClick, "data-testid": dataTestId },
                React.createElement(CustomStrong, { className: styles.customStrong, type: strong }, children)));
        case 'labelSmall':
            return (React.createElement("small", { className: styles.labelSmall + " " + className, onClick: onClick, "data-testid": dataTestId },
                React.createElement(CustomStrong, { className: styles.customStrong, type: strong }, children)));
        default:
            return (React.createElement("span", { className: className, onClick: onClick, "data-testid": dataTestId },
                React.createElement(CustomStrong, { className: styles.customStrong, type: strong }, children)));
    }
};
var CustomTypography = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId, children = _a.children, variant = _a.variant, onClick = _a.onClick, strong = _a.strong;
    return obtenerDOM({ className: className, variant: variant, strong: strong, children: children, onClick: onClick, dataTestId: dataTestId });
};
CustomTypography.defaultProps = {
    className: '',
    dataTestId: '',
};
export default CustomTypography;
